import { render, staticRenderFns } from "./RegulatoryUpdateAnnouncementPF.vue?vue&type=template&id=23c25f65&scoped=true"
import script from "./RegulatoryUpdateAnnouncementPF.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateAnnouncementPF.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateAnnouncementPF.vue?vue&type=style&index=0&id=23c25f65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c25f65",
  null
  
)

export default component.exports